import React, { useEffect } from 'react';
import { useSpring, animated } from '@react-spring/web';
import { useDrag } from '@use-gesture/react';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Drawer: React.FC<DrawerProps> = ({ isOpen, onClose, children }) => {
  const [{ x }, api] = useSpring(() => ({ x: isOpen ? 0 : -250 }));

  const openDrawer = () => api.start({ x: 0 });
  const closeDrawer = () => api.start({ x: -250 });

  const bind = useDrag(({ movement: [mx], active }) => {
    if (active) {
      api.start({ x: Math.min(0, mx - 250) });
    } else {
      if (mx > -100) openDrawer();
      else closeDrawer();
    }
  });

  useEffect(() => {
    if (isOpen) openDrawer();
    else closeDrawer();
  }, [isOpen]);

  return (
    <animated.div
      {...bind()}
      style={{
        transform: x.to((val) => `translate3d(${val}px, 0, 0)`),
        position: 'fixed',
        top: 0,
        left: 0,
        width: '250px',
        height: '100%',
        background: '#333',
        color: '#fff',
        zIndex: 1000,
        touchAction: 'none',
      }}
    >
      <button onClick={onClose}>Close</button>
      {children}
    </animated.div>
  );
};

export default Drawer;
